import gql from 'graphql-tag'

export type ChildGender = 'BOY' | 'GIRL' | 'OTHER'

export interface IChildPreviousChildcareExperience {
  stayAtHomeParent: boolean
  familyMember: boolean
  nanny: boolean
  sharecare: boolean
  childcare: boolean
  childcareCenter: boolean
}

export interface IChild {
  id: number
  name: string | null
  firstName: string | null
  lastName: string | null
  avatarUrl: string | null
  gender: ChildGender | null
  birthday: string | null
  desiredEnrollmentDate: string | null
  allergies: string | null
  medications: string | null
  medicalConditions: string | null
  habitsAndBehaviors: string | null
  previousChildcareExperience: IChildPreviousChildcareExperience | null

  // Special needs
  metalOrGlassOnly: string | null
  compostableDiapers: string | null
  dietaryRestrictions: string | null
  animalAllergiesOrFear: string | null
  limitedEnglishExposure: string | null
  unvaccinated: string | null
  specialNeeds: string | null
  other: string | null
}

export const ChildFieldsFragment = gql`
  fragment ChildFields on Child {
    id
    name
    firstName
    lastName
    avatarUrl
    gender
    birthday
    desiredEnrollmentDate
    allergies
    medications
    medicalConditions
    habitsAndBehaviors
    previousChildcareExperience {
      stayAtHomeParent
      familyMember
      nanny
      sharecare
      childcare
      childcareCenter
    }

    metalOrGlassOnly
    compostableDiapers
    dietaryRestrictions
    animalAllergiesOrFear
    limitedEnglishExposure
    unvaccinated
    specialNeeds
    other
  }
`
